// Exact copy except import UserService from shared
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { LostCredentialsService } from "./lostCredentials.service";
import { SecretQuestionAnswers, SecretQuestion, QuestionCodeAnswer, LostCredentials, Error } from "../../models";
import { UserAuthenticationService } from "../../services/shared";
import {NgProgressService} from "ng2-progressbar";

@Component({
    template: require("./lostCredentials.component.html"),
    styles: [require("./lostCredentials.component.less").toString()],
    providers: [LostCredentialsService]
})
export class LostCredentialsComponent implements OnInit {
    secretQuestionAnswers: SecretQuestionAnswers;
    secretQuestions: SecretQuestion[];
    questionCodeAnswer: QuestionCodeAnswer;
    errorMessage: string;
    errors: Error[];
    isProcessing: boolean;
    attempt: number;
    userfound: boolean;
    isMatch: boolean;
    completedAttempts: boolean;
    lostCredentials: LostCredentials;
    recoveryAttempt: number = 0;
    

    constructor(public userAuthService: UserAuthenticationService, private pService: NgProgressService, private lostCredentialsService: LostCredentialsService, private cecRouter: Router) {
        this.lostCredentials = new LostCredentials();
        this.errorMessage = "";
        this.errors = [];
        this.userfound = false;
        this.isProcessing = false;
        this.completedAttempts = false;
        this.attempt = 0;
        this.isMatch = false;
    }

    ngOnInit() {
        if (this.userAuthService.isAuthenticated) {
            this.cecRouter.navigate(["/home"]);
        }

        this.secretQuestionAnswers = new SecretQuestionAnswers();
        this.secretQuestionAnswers.questionCodeAnswers = [new QuestionCodeAnswer()];
        this.questionCodeAnswer = new QuestionCodeAnswer();
        this.lostCredentials = new LostCredentials();
    }
    /**Validates the user id and loads the secret questions. */
    public GetSecretQuestions(): void {
        if (this.secretQuestionAnswers.userId === undefined || this.secretQuestionAnswers.userId.trim() === "") {
            return;
        }
        this.errorMessage = "";
        this.errors = [];
        this.isProcessing = true;
        this.pService.start();
        this.lostCredentialsService
            .GetSecretQuestionsAnswers(this.secretQuestionAnswers.userId)
            .subscribe(
            (response: SecretQuestionAnswers) => {
                this.secretQuestionAnswers = response;
                this.lostCredentials.userId = this.secretQuestionAnswers.userId;
                this.userfound = true;
            },
            (error) => {
                this.recoveryAttempt += 1;
                let parsedErrors = JSON.parse(error._body);
                this.SetErrorMessage(parsedErrors);
            }).add(c => {
                this.isProcessing = false;
            });

        this.pService.done();
    }

    public IsCorrectQuestionAnswer(): void {

        if (!this.userfound) {
            this.GetSecretQuestions();
            return;
        }

        this.isProcessing = true;
        this.pService.start();
        if (this.isMatch) {
            if (this.lostCredentials.password !== this.lostCredentials.confirmPassword) {
                this.errorMessage = "Input validation failed:";
                this.errors.push({ code: "confirmPassword", message: "Passwords do not match" });
                this.isProcessing = false;
            }
            else {

                this.lostCredentialsService
                    .Save(this.lostCredentials)
                    .subscribe(
                    (response: LostCredentials) => this.cecRouter.navigate(["/lostCredentialsConfirmation"]),
                    (error) => {
                        let parsedErrors = JSON.parse(error._body);
                        this.SetErrorMessage(parsedErrors);
                    }).add(c => {
                        this.isProcessing = false;
                        this.pService.done();
                    });
            }
            return;
        }

        this.secretQuestionAnswers.questionCodeAnswers.forEach(i => {
            i.answer = i.answer.trim();
        });

        this.lostCredentialsService
            .IsCorrectQuestionAnswer(this.secretQuestionAnswers)
            .subscribe(
            (response: boolean) => {
                this.isMatch = response;
                if (!this.isMatch) {
                    this.recoveryAttempt += 1;
                    if (this.attempt === 2) {
                        this.completedAttempts = true;
                        this.attempt = 0;
                        this.errorMessage = "Atleast one correct answer is needed for secret question";
                        let mess = new Error();
                        mess.message = "Unable to reset password!";
                        mess.code = "MaxLimit";
                        this.errors.push(mess);
                    }
                    else {
                        this.attempt++;
                    }
                }
            },
            (error) => {
                let parsedErrors = JSON.parse(error._body);
                this.SetErrorMessage(parsedErrors);
            }).add(c => {
                this.isProcessing = false;
                this.pService.done();
            });

        this.pService.done();
    }

    private SetErrorMessage(parsedErrors): void {
        if (parsedErrors) {
            this.errorMessage = parsedErrors.message;
            this.errors = parsedErrors.errors;
        }
    }

    public onSubmit(): void {
        this.isProcessing = false;
    }
}





// WEBPACK FOOTER //
// ./src/app/modules/lostCredentials/lostCredentials.component.ts